module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Elodie-meisje-letterpress-roze-thumbnail.400d93f1.png";